import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupplierContact, SupplierContactCreate, SupplierContactFilter } from '../data/supplierContact';

export function createSupplierContactService(client: AxiosInstance) {
  return createCrudService<SupplierContact, SupplierContactCreate, SupplierContactFilter>(
    client,
    '/purchase/SupplierContact',
    'id',
  );
}

export type SupplierContactService = CrudService<SupplierContact, SupplierContactCreate, SupplierContactFilter>;
